// AUTO-GENERATED by scripts/write-build-version.ts — do not edit.
// Empty string = version key disabled (current/pre-deploy-skew behaviour).
export const BUILD_VERSION = "482b0440a91e79cdf88aea453bc0a03f";
// The git sha, ALWAYS — BUILD_VERSION is a render-identity hash under
// CACHE_NAMESPACE_PIN=1 and cannot be compared against a commit.
export const BUILD_COMMIT = "d42fde3a6aca";
